import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const run = async () => {
      const hash = window.location.hash;
      const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
      if (!sid) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(res.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B1120] text-slate-400">
      <div className="animate-pulse font-display tracking-widest text-sm uppercase">Signing you in…</div>
    </div>
  );
}
